export default __webpack_public_path__ + "static/media/OrangeCard.97fb2a51.svg";